import { InvoiceAs400SyncKind, InvoiceStatus, InvoiceType, PaymentMethod } from "@/graphql/codegen/graphql"

export const INVOICE_STATUS_LABELS: Record<InvoiceStatus, string> = {
  [InvoiceStatus.PendingApproval]: "Pending Approval",
  [InvoiceStatus.Approved]: "Approved",
  [InvoiceStatus.NotApproved]: "Not Approved",
  [InvoiceStatus.Paid]: "Paid",
  [InvoiceStatus.Cancelled]: "Cancelled",
  [InvoiceStatus.Voided]: "Voided",
}

// Tailwind class maps for the Status column chip. Mirrors the Transactions screen pattern
// (`getStatusChipClassName` in `useTransactionsColumns.tsx`).
export const INVOICE_STATUS_CHIP_CLASSES: Record<InvoiceStatus, string> = {
  [InvoiceStatus.PendingApproval]: "bg-tertiary-orange-300 text-gray-900",
  [InvoiceStatus.Approved]: "bg-primary-200 text-gray-900",
  [InvoiceStatus.NotApproved]: "bg-secondary-200 text-gray-900",
  [InvoiceStatus.Paid]: "bg-tertiary-green-300 text-gray-900",
  [InvoiceStatus.Cancelled]: "bg-gray-300 text-gray-900",
  [InvoiceStatus.Voided]: "bg-gray-300 text-gray-900",
}

export const INVOICE_PAYMENT_METHOD_LABELS: Record<PaymentMethod, string> = {
  [PaymentMethod.Check]: "Check",
  [PaymentMethod.Ach]: "ACH",
  [PaymentMethod.Wire]: "Wire",
  [PaymentMethod.CreditCard]: "Virtual Credit Card",
  [PaymentMethod.Cash]: "Cash",
}

export const INVOICE_TYPE_LABELS: Record<InvoiceType, string> = {
  [InvoiceType.General]: "General",
  [InvoiceType.Po]: "PO",
}

export const INVOICE_AS400_SYNC_KIND_TO_LABEL: Record<InvoiceAs400SyncKind, string> = {
  [InvoiceAs400SyncKind.Approve]: "Approval sync",
  [InvoiceAs400SyncKind.Paid]: "Payment sync",
  [InvoiceAs400SyncKind.Reversal]: "Reversal sync",
  [InvoiceAs400SyncKind.Void]: "Void sync",
}
